import React from 'react';
import Sidebar from '../components/Layout/Sidebar';
import Billing from '../components/Profile/Billing';
const BillingPage = () => {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <Billing />
      </div>
    </div>
  );
};
export default BillingPage;